import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'featureName',
    title: 'Feature Name',
    show: true,
    width: 320,
    valuesExport: ['featureName']
  },
  {
    isSortable: true,
    field: 'action',
    title: 'Action',
    show: true,
    width: 132,
    valuesExport: ['action']
  },
  {
    isSortable: true,
    field: 'updatedByName',
    title: 'Updated By',
    show: true,
    width: 280,
    valuesExport: ['updatedByName', 'updatedByEmail']
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Status',
    show: true,
    width: 162,
    valuesExport: ['status']
  },
  {
    isSortable: false,
    field: 'assignedIds',
    title: 'Assigned',
    show: true,
    width: 136,
    valuesExport: ['assignedIds']
  },
  {
    isSortable: false,
    field: 'unassignedIds',
    title: 'Unassigned',
    show: true,
    width: 136,
    valuesExport: ['unassignedIds']
  },
  {
    isSortable: true,
    field: '_created_at',
    title: 'Created At',
    show: true,
    width: 136,
    valuesExport: ['_created_at']
  }
];

export const defaultFilters = {
  search: '',
  action: [],
  status: [],
  updatedByName: [],
  _created_at: [],
  isTestTenant: ''
};

export const defaultNavigation = {
  fieldName: '_created_at',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
